import React, { Component, useState, useEffect, useRef } from "react";
import { Container, Row, Col } from 'react-grid-system';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import blurbs from './blurbs';
import './App.css';

const ALL_WORDS = blurbs.flatMap(b => b.split(' '));

function ordinal(n) {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

function LocalTime() {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  const tz = 'America/New_York';
  const weekday = now.toLocaleDateString('en-US', { timeZone: tz, weekday: 'long' });
  const month = now.toLocaleDateString('en-US', { timeZone: tz, month: 'long' });
  const day = parseInt(now.toLocaleDateString('en-US', { timeZone: tz, day: 'numeric' }));
  const year = now.toLocaleDateString('en-US', { timeZone: tz, year: 'numeric' });
  const time = now.toLocaleTimeString('en-US', { timeZone: tz, hour: 'numeric', minute: '2-digit' });
  return <span>{weekday}, {month} {ordinal(day)}, {year} at {time}</span>;
}

function CyclingBlurb({ blurbs }) {
  const initRef = useRef(Math.floor(Math.random() * blurbs.length));
  const [curIdx, setCurIdx] = useState(initRef.current);
  const [words, setWords] = useState(() => blurbs[initRef.current].split(' '));

  useEffect(() => {
    const nextIdx = (curIdx + 1) % blurbs.length;
    const nextWords = blurbs[nextIdx].split(' ');
    const ids = [];

    const swapCount = Math.random() < 0.5 ? 1 : 2;
    const positions = [];
    while (positions.length < swapCount) {
      const p = Math.floor(Math.random() * Math.min(words.length, nextWords.length));
      if (!positions.includes(p)) positions.push(p);
    }
    positions.sort((a, b) => a - b);

    const TICK = 55;
    const FLICKER = 10;

    let t = 2500;
    positions.forEach((pos, ii) => {
      const finalWord = nextWords[pos];
      for (let f = 0; f < FLICKER; f++) {
        const scramble = ALL_WORDS[Math.floor(Math.random() * ALL_WORDS.length)];
        ids.push(setTimeout(() => {
          setWords(prev => {
            const updated = [...prev];
            updated[pos] = scramble;
            return updated;
          });
        }, t + f * TICK));
      }
      ids.push(setTimeout(() => {
        setWords(prev => {
          const updated = [...prev];
          updated[pos] = finalWord;
          return updated;
        });
      }, t + FLICKER * TICK));

      t += FLICKER * TICK + (ii < positions.length - 1 ? 180 : 0);
    });

    ids.push(setTimeout(() => setCurIdx(nextIdx), t + 2500));
    return () => ids.forEach(clearTimeout);
  }, [curIdx]);

  return (
    <span>
      {words.map((word, i) => (
        <span key={i} style={{ display: 'inline-block' }}>
          {word}{'\u00a0'}
        </span>
      ))}
    </span>
  );
}



function getEffectiveBg(el) {
  let node = el;
  let depth = 0;
  while (node && node.tagName !== 'BODY' && depth < 12) {
    // Skip past any nav-ignore container (e.g. color palette swatches)
    const ignored = node.closest('[data-nav-ignore]');
    if (ignored) {
      node = ignored.parentElement;
      depth++;
      continue;
    }
    const bg = window.getComputedStyle(node).backgroundColor;
    if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') return bg;
    node = node.parentElement;
    depth++;
  }
  // Also check body and html for inline background styles
  for (const docEl of [document.body, document.documentElement]) {
    const bg = docEl.style.backgroundColor;
    if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') return bg;
  }
  return 'rgb(0,0,0)';
}

function isLightColor(color) {
  let r, g, b;
  const rgb = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
  if (rgb) {
    [, r, g, b] = rgb.map(Number);
  } else {
    const hex = color.replace('#', '');
    const full = hex.length === 3 ? hex.split('').map(c => c + c).join('') : hex;
    r = parseInt(full.slice(0, 2), 16);
    g = parseInt(full.slice(2, 4), 16);
    b = parseInt(full.slice(4, 6), 16);
  }
  return (0.299 * r + 0.587 * g + 0.114 * b) > 128;
}

const SESSION_KEY = 'experiments_unlocked';
const PASSWORD = 'vanits';

function ExperimentsNavItem({ pathname }) {
  const unlocked = sessionStorage.getItem(SESSION_KEY) === '1';
  const [input, setInput] = useState('');
  const [error, setError] = useState(false);

  if (pathname !== '/experiments' || unlocked) {
    return (
      <Link to="/experiments" className="nav-experiments-link" style={{ color: 'inherit', textDecoration: 'none' }}>
        <span className="nav-experiments-label">Experiments</span>
        <span className="nav-experiments-hover">Shhhhhhhhh</span>
      </Link>
    );
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input === PASSWORD) {
      sessionStorage.setItem(SESSION_KEY, '1');
      window.location.reload();
    } else {
      setError(true);
      setInput('');
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ margin: 0 }}>
      <input
        className="experiments-password-input"
        type="password"
        value={input}
        onChange={e => { setInput(e.target.value); setError(false); }}
        placeholder="Password"
        autoFocus
        style={{
          background: 'none',
          border: 'none',
          outline: 'none',
          fontSize: 13,
          fontFamily: 'inherit',
          color: error ? '#ff0000' : 'inherit',
          caretColor: 'inherit',
          padding: 0,
          margin: 0,
          width: '100%',
        }}
      />
    </form>
  );
}

class Nav extends Component {
  state = { bg: 'transparent', light: false };

  updateNavColor = (ignoreLightNav = false) => {
    if (!ignoreLightNav && this.props.lightNav) {
      const color = this.props.lightNav;
      this.setState({ bg: color, light: isLightColor(color) });
      return;
    }
    if (this.props.coverPresent === 'yes' && window.scrollY < window.innerHeight) {
      this.setState({ bg: 'rgba(0,0,0,0)', light: false });
      return;
    }
    const navEl = document.querySelector('.nav');
    const navH = navEl ? navEl.getBoundingClientRect().bottom : (this._navH || 70);
    const el = document.elementFromPoint(window.innerWidth / 2, navH + 2);
    if (!el) return;
    const color = getEffectiveBg(el);
    this.setState({ bg: color, light: isLightColor(color) });
  };

  componentDidMount() {
    const navEl = document.querySelector('.nav');
    this._navH = navEl ? navEl.offsetHeight : 70;
    this.updateNavColor();

    this._rafId = null;
    const onScroll = () => {
      if (this._rafId) return;
      this._rafId = requestAnimationFrame(() => {
        this._rafId = null;
        this.updateNavColor();
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    this._removeScroll = () => window.removeEventListener('scroll', onScroll);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.pathname !== this.props.pathname) {
      // ScrollToTop runs in useLayoutEffect (before paint), so scrollY is already 0.
      // Cancel any scroll-triggered rAF and sample synchronously before the paint.
      if (this._rafId) { cancelAnimationFrame(this._rafId); this._rafId = null; }
      this.updateNavColor(true);
      return;
    }
    if (prevProps.coverPresent !== this.props.coverPresent ||
        prevProps.lightNav !== this.props.lightNav) {
      this.updateNavColor();
    }
  }

  componentWillUnmount() {
    if (this._removeScroll) this._removeScroll();
    if (this._rafId) cancelAnimationFrame(this._rafId);
  }

  render() {
    const { bg, light } = this.state;
    return (
      <>
        <div className={`nav${light ? ' nav-light' : ''}`} style={{ backgroundColor: bg }}>
  	  		<div className="inner-wrapper">
  				<Container fluid className="page-pad">
  				<div className="nav-inner">

  					<Row>

  						<Col sm={3} className="nav-col-name">
  							<div className="navleft">
  							<Link to= {"/"} className="item nav-home-link">
    <span className="nav-home-name">Maria Chimish<span style={{letterSpacing:'0.3px'}}>k</span>yan</span>
    <span className="nav-home-label">View all work</span>
  </Link>
  							</div>
  						</Col>

  						<Col sm={3} className="nav-col-blurb">
  							<div className="nav-blurb" style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: '85%' }}><CyclingBlurb blurbs={blurbs} /></div>
  						</Col>

  						<Col sm={3} className="nav-col-commissions">
  							<div className="nav-blurb">
  								<Link to="/commissions" style={{ color: 'inherit', textDecoration: 'none' }}>Editorial Commissions</Link>
  							</div>
  						</Col>

  						<Col sm={3} className="nav-col-experiments">
  							<div className="nav-blurb">
  								<ExperimentsNavItem pathname={this.props.pathname} />
  							</div>
  						</Col>

  						<Col sm={3} className="nav-col-info">
  							<div className="navright">
  							<Link to= {"/info"} className="item nav-info-link">
    <span className="nav-info-label">Info</span>
    <span className="nav-info-hover">About a rainbow</span>
  </Link>
  							</div>
  						</Col>

  					</Row>

  				</div>
  				</Container>
  			</div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return { coverPresent: state.coverPresent, lightNav: state.lightNav };
};


export { CyclingBlurb, ExperimentsNavItem };
export default connect(mapStateToProps)(Nav);
